/**
 * Desktop Layout Constants
 * Centralized constants for desktop layout dimensions and configurations
 */

export const LAYOUT_CONSTANTS = {
  // Drawer dimensions
  DRAWER_WIDTH: 280,
  DRAWER_WIDTH_MOBILE: 280,
  NOTIFICATION_PANEL_WIDTH: 320,

  // AppBar dimensions
  APPBAR_HEIGHT: 64,

  // Breakpoint keys for responsive behavior
  BREAKPOINTS: {
    MOBILE: 'sm',
    TABLET: 'md',
    DESKTOP: 'lg'
  },

  // Animation durations
  TRANSITIONS: {
    STANDARD: 'standard',
    SHORT: 'short',
    ENTERING: 'enteringScreen',
    LEAVING: 'leavingScreen'
  },

  // Z-index values
  Z_INDEX: {
    APPBAR: 1200,
    DRAWER: 1100,
    NOTIFICATION_PANEL: 1100
  }
} as const;

export type LayoutConstants = typeof LAYOUT_CONSTANTS;
